import React from 'react';
import './Styles.css';
import EditCreateViewSetter from './EditCreateViewSetter';
import { useGlobalAddressContext } from '../../AddressInfo';
import AddressFormatSelector from './AddressFormatSelector';
import AddressViewTop from './AddressViewTop';
import { PresentationMode } from '../../../../../../../Enums/PresentationMode';
import Form from '../../../../../../../Elements/Form';
import { onSubmit } from './Functions';
import { addressFormId } from '../../CommonFunctions';
import { useTeamPageContext } from '../../../../../TeamPage';
import AddressFormatSwitcher from '../../../../../../../Elements/AddressFormatSwitcher';
import { addressReducerTypes } from '../../Reducer';

const AddressView = () => {
  const {
    modalMode,
    setModalMode,
    addressState,
    agentCode,
    codePrefix,
    isModalOpenedOnTeamLevel,
    addressDispatch,
    countryList,
    getCommonFields,
  } = useGlobalAddressContext();

  const { teamPageDispatch } = useTeamPageContext();

  return (
    <div className="team-page_address-info_container">
      <AddressViewTop />
      <EditCreateViewSetter />
      <Form
        formId={addressFormId}
        onSubmit={e => {
          onSubmit(
            e,
            agentCode,
            codePrefix,
            isModalOpenedOnTeamLevel,
            addressState.address,
            setModalMode,
            addressDispatch,
            teamPageDispatch
          );
        }}
        disabled={modalMode === PresentationMode.View}>
        {modalMode === PresentationMode.Add ? (
          <>
            <AddressFormatSelector />
            <AddressFormatSwitcher
              addressState={addressState}
              setAddressState={newState => addressDispatch({ type: addressReducerTypes.setNewState, newState })}
              countryList={countryList}
              getCommonFields={getCommonFields}
              modalMode={modalMode}
            />
          </>
        ) : (
          <AddressFormatSwitcher
            addressState={addressState}
            setAddressState={newState => addressDispatch({ type: addressReducerTypes.setNewState, newState })}
            countryList={countryList}
            getCommonFields={getCommonFields}
            modalMode={modalMode}
          />
        )}
      </Form>
    </div>
  );
};

export default AddressView;
